/**************************************************
 * Nombre:       Formulario_Tratamientos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {
    AccountCircleOutlined,
    BadgeOutlined,
    FlagOutlined,
    MailOutline,
    PhoneAndroidOutlined
} from "@mui/icons-material";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import {TIPOSPERFILACION} from "../../Constantes";

const Formulario_Tratamientos = ({...props}) => {

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Nombre Completo'} dato={'nombre'} {...props}
                                  requerido={'Dato Requerido'}

                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 6}}>
                    <IngresoTexto Icono={BadgeOutlined} nombre={'Num Identificacion'} dato={'cc'} {...props}
                                  requerido={'Dato Requerido'}

                    />
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 6}}>
                    <IngresoTexto Icono={PhoneAndroidOutlined} nombre={'Num Celular'} dato={'celular'} {...props}
                                  requerido={'Dato Requerido'}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={MailOutline} nombre={'Correo electronico'} dato={'correo'} {...props}
                                  requerido={'Dato Requerido'}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoSelect Icono={FlagOutlined} nombre={'Tipo de Trámite '} dato={'tipo'} {...props}
                                   requerido={'Dato Requerido'} opciones={TIPOSPERFILACION.map((it) => it.nombre)}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto lineas={8} nombre={'Resumen Breve del Conflicto o Consulta'} dato={'mensaje'} {...props}
                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Tratamientos